export const GOOGLE_VENDOR_ID = 755
export const MEDIAVINE_VENDOR_ID = 858
